import { useAppDispatch } from 'common/hooks/redux';
import { FlyoutFooter } from '../Flyout';
import { Button } from '@progress/kendo-react-buttons';
import { selectPptExportables, setWizardStep } from 'common/store/slices/export-ppt.slice';
import { Loader } from '@progress/kendo-react-indicators';
import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { paginatedExportPages } from '../PowerpointExportWizard';
import useApiLoadingState from 'common/hooks/useApiLoadingState';
import { useSelector } from 'react-redux';
import { WizardStep } from '../../../models/pptx.model';

interface FooterProps {
  onExport: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

function Footer({ onExport, isLoading, disabled }: Readonly<FooterProps>) {
  const dispatch = useAppDispatch();
  const { compareUrl } = useCompareUrlWithProjectId();
  const { chartApiLoadingState } = useApiLoadingState({ includeAllQueries: true });

  const { failedWidgetIds } = chartApiLoadingState;

  const exportables = useSelector(selectPptExportables);

  const exportableKeys = Object.keys(exportables);

  const missingKeys = exportableKeys.filter((key) => !failedWidgetIds.includes(key));
  const disableExport = missingKeys.length === 0;

  const showBackButton = compareUrl(paginatedExportPages);

  return (
    <FlyoutFooter>
      {showBackButton && (
        <Button
          fillMode="flat"
          themeColor={'secondary'}
          size={'large'}
          onClick={() => dispatch(setWizardStep(WizardStep.PowerpointExportChooseOption))}
        >
          Back
        </Button>
      )}
      <Button
        fillMode={isLoading ? 'outline' : 'solid'}
        size={'large'}
        themeColor={'primary'}
        onClick={() => !isLoading && onExport()}
        disabled={!chartApiLoadingState.isSuccess || isLoading || disabled || disableExport}
      >
        {isLoading ? (
          <span className="loader">
            <Loader size="medium" type="pulsing" />
          </span>
        ) : (
          'Export'
        )}
      </Button>
    </FlyoutFooter>
  );
}

export default Footer;
